import { lireBibliotheque, trouverFiche, lireResultFin, estRetiree, choisirContenuBilan, parcoursTermine } from './contenuBilan'
import { moduleTermine } from '../Certificat/moduleTermine'
import BIBLIOTHEQUE_JSON from './bibliotheque_18_competences.json'

/* ⛔ BILAN SOFT SKILLS, ETAPE 2 : LES DONNEES REELLES DE L'APPRENANT
   (07/10/2026). Tout se calcule dans le navigateur, a partir de ce que le
   tableau de bord a deja (`currentUser`, `actPlan`) : aucun appel serveur.

   POUR QUI : les apprenants (type « student »), jamais les candidats THE
   SCAN. La ligne n'existe que si le plan contient au moins un module qui
   mesure une competence du referentiel : une entree de son
   `softSkillsFromContent` (le champ `softSkills` du module : { key, value })
   qui n'est pas « non » et qui a une fiche dans la bibliotheque des 18.

   LES SCORES : les `resultFin` des modules TERMINES du plan (isDone et 100 %,
   comme le certificat), icebreaker exclu. Seules comptent les 18 competences
   du referentiel (une fiche) : multitache et autonomie, les echelles T1 et
   T2, la satisfaction, master et glbMaster n'en sont jamais ; une categorie
   que le module marque « non » non plus. Une competence mesuree dans
   plusieurs modules : celle du DERNIER module termine (date de fin `doneAt`,
   sinon l'ordre du plan).

   ETATS DE LA LIGNE :
     - « verrouillee » : parcours pas termine (icebreaker et tous les modules,
       isDone et 100 %) ;
     - « incomplete » : parcours termine, mais moins de 3 competences du
       referentiel mesurees (message neutre) ;
     - « disponible » : le bilan peut s'ouvrir.

   « DÉLIVRÉ LE » : le `doneAt` le plus recent des modules du plan, sinon la
   date du jour (juste apres la fin, `doneAt` n'arrive qu'au rechargement).
   LE PARCOURS : le `titrePlan` du premier groupe de l'apprenant s'il arrive
   dans ses donnees ; sinon rien (aucune valeur inventee). */

export const BIBLIOTHEQUE = lireBibliotheque(BIBLIOTHEQUE_JSON)

const marquesNon = (module) => new Set((module?.softSkillsFromContent || [])
  .filter((s) => s && s.value === 'non').map((s) => String(s.key)))

export const planMesureDesCompetences = (actPlan, bibliotheque = BIBLIOTHEQUE) => Array.isArray(actPlan)
  && actPlan.slice(1).some((m) => (m?.softSkillsFromContent || [])
    .some((s) => s && s.value !== 'non' && !estRetiree(s.key) && trouverFiche(bibliotheque, s.key)))

const instant = (d) => {
  if (!d) return NaN
  const t = new Date(d).getTime()
  return Number.isFinite(t) ? t : NaN
}

/* les modules termines, du plus ancien au plus recent */
const modulesTermines = (actPlan) => (Array.isArray(actPlan) ? actPlan.slice(1) : [])
  .map((m, i) => ({ m, i, t: instant(m?.doneAt) }))
  .filter(({ m }) => moduleTermine(m) && lireResultFin(m?.resultFin))
  .sort((a, b) => ((Number.isFinite(a.t) ? a.t : -Infinity) - (Number.isFinite(b.t) ? b.t : -Infinity)) || (a.i - b.i))

/* les seuils du Diagnostic d'une categorie, du plus haut au plus bas */
const seuilsDuModule = (module, cle) => {
  const s = (module?.seuils || []).find((x) => x?.key === cle)
  const v = (s?.value?.seuil || []).map((x) => Number(x?.seuil)).filter(Number.isFinite)
  return v.length ? v.sort((a, b) => b - a) : undefined
}

export const scoresDuParcours = (actPlan, bibliotheque = BIBLIOTHEQUE) => {
  const scores = {}
  const seuils = {}
  modulesTermines(actPlan).forEach(({ m }) => {
    const r = lireResultFin(m.resultFin)
    const non = marquesNon(m)
    Object.entries(r).forEach(([cle, v]) => {
      const score = Number(v?.score)
      if (!Number.isFinite(score) || typeof v?.score === 'boolean' || v?.score === '' || v?.score === null) return
      if (cle === 'master' || cle === 'glbMaster' || estRetiree(cle) || non.has(cle)) return
      const fiche = trouverFiche(bibliotheque, cle)
      if (!fiche) return
      scores[fiche.cle] = score
      const s = seuilsDuModule(m, cle)
      if (s) seuils[fiche.cle] = s
      else delete seuils[fiche.cle]
    })
  })
  return { scores, seuils }
}

export const dateDuBilan = (actPlan, maintenant = new Date()) => {
  const t = (Array.isArray(actPlan) ? actPlan : []).map((m) => instant(m?.doneAt)).filter(Number.isFinite)
  return t.length ? new Date(Math.max(...t)) : maintenant
}

export const titreDuPlan = (currentUser) => {
  const t = currentUser?.groupes?.[0]?.titrePlan
  return typeof t === 'string' && t.trim() ? t.trim() : ''
}

export const etatDuBilan = ({ currentUser, actPlan, public: pub = 'etudiant', bibliotheque = BIBLIOTHEQUE, maintenant = new Date() }) => {
  const visible = currentUser?.type === 'student' && planMesureDesCompetences(actPlan, bibliotheque)
  if (!visible) return { visible: false, etat: null, donnees: null }
  if (!parcoursTermine(actPlan)) return { visible: true, etat: 'verrouillee', donnees: null }
  const { scores, seuils } = scoresDuParcours(actPlan, bibliotheque)
  const contenu = choisirContenuBilan({ scores, seuils, bibliotheque, public: pub })
  if (!contenu) return { visible: true, etat: 'incomplete', donnees: null }
  return {
    visible: true,
    etat: 'disponible',
    donnees: {
      prenomNom: String(currentUser?.name || '').trim(),
      nomParcours: titreDuPlan(currentUser),
      contenu,
      dateDelivrance: dateDuBilan(actPlan, maintenant),
    },
  }
}
